import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import './index.css';
import App from './components/App';
import Adviento from './components/advientogt1';
import Advientos from './components/adviento0sv';
import login from './components/login';
import Admin from './components/admin' ;
import Salva from './components/Dashboard/SV' ;
import registro from './components/Registro';
import PrivateRoute from './components/PrivateRoute';

const root = document.getElementById('root');

const nodes = (
  <Router slash={false}>
    <Switch>
      <PrivateRoute exact path="/calendario-navideño-gt" component={Adviento}></PrivateRoute>
      <PrivateRoute exact path="/calendario-navideño-sv" component={Advientos}></PrivateRoute>
      <PrivateRoute exact path="/navideño-admin" component={Admin}></PrivateRoute>
      <PrivateRoute exact path="/navideño-admin-sv" component={Salva}></PrivateRoute>
      <Route exact path="/login" component={login}></Route>
      <Route exact path="/registro" component={registro}></Route>
      <Route exact path="/home" component={App}></Route>
      <Redirect from="/" to="/home"></Redirect>
    </Switch>
  </Router>
);

const rootElement = ReactDOM.createRoot(root);
rootElement.render(nodes);